import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { PeopleForm } from '@/features/featured-people/components/PeopleForm';
import { usePeopleFormPicker } from '@/features/featured-people/hooks/use-people-form-picker';
import { TFeaturedPeopleForm } from '@/features/featured-people/types';
import { getAbsoluteDateFromPlayerTime } from '@/utils/hh-mm-ss-into-number';

import { useBroadcastScheduleProgramBodySegmentToolkitPeopleFormState } from '../hooks/useBroadcastScheduleProgramBodySegmentToolkitPeopleFormState';

export function BroadcastScheduleProgramBodySegmentToolkitPeopleForm() {
  const { activeSegment, playerVideoCurrentTime, handleDateTimeSegment, personaData, formBox } =
    useBroadcastScheduleProgram();
  const {
    form,
    isCreatingPeople,
    peopleDrawer,
    handleSubmitPeople,
    renderAdditionalButtons,
    handleClickExit,
    handleSubmit,
  } = useBroadcastScheduleProgramBodySegmentToolkitPeopleFormState();

  const { picker, selectedPerson, selectCreatedPerson } = usePeopleFormPicker({
    form,
    fallbackLabel: personaData?.entity_label,
    syncLabel: formBox === 'people',
  });

  const handleClickAdd = () => {
    if (!activeSegment?.start_datetime) return;

    const newDateTime = getAbsoluteDateFromPlayerTime(
      activeSegment.start_datetime,
      playerVideoCurrentTime
    );

    form.setValue('start_datetime', newDateTime);
    form.setValue('end_datetime', newDateTime);
  };

  const handleCreatePerson = async (data: TFeaturedPeopleForm) => {
    const person = await handleSubmitPeople(data);
    selectCreatedPerson(person);
    return person;
  };

  return (
    <PeopleForm
      form={form}
      peoplePicker={picker}
      selectedPeople={selectedPerson}
      isCreatingPeople={isCreatingPeople}
      peopleDrawer={peopleDrawer}
      handleClickAdd={handleClickAdd}
      handleClickExit={handleClickExit}
      handleSubmit={handleSubmit}
      handleSubmitPeople={handleCreatePerson}
      renderAdditionalButtons={renderAdditionalButtons}
      onClickTooltipDate={name => handleDateTimeSegment(form, name)}
    />
  );
}
